import { render, staticRenderFns } from "./EditorCanvas.vue?vue&type=template&id=b720df40&scoped=true&"
import script from "./EditorCanvas.vue?vue&type=script&lang=js&"
export * from "./EditorCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b720df40",
  null
  
)

export default component.exports